import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./Header.css";
import { BsTelegram, BsTwitter } from "react-icons/bs";
import { AiOutlineMenu } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import logo from "../Assets/pikachuLogo-removebg-preview.png";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";

export default function Header() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  return (
    <div>
      <Navbar
        collapseOnSelect
        expand="lg"
        className="main_nav_bar"
        style={{ paddingRight: "3rem !important" }}
      >
        <Container>
          <Navbar.Brand href="#home" className="logo_main_width">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </Navbar.Brand>

          <span className="d-block d-lg-none" onClick={() => setShow(!show)}>
            {show ? (
              <>
                <RxCross2 className="text-white fs-1" />{" "}
              </>
            ) : (
              <>
                <AiOutlineMenu className="text-white fs-1" />
              </>
            )}
          </span>
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className={show ? "show" : ""}
          >
            <Nav className="ms-auto gap-4">
              <Nav.Link className="headeder_links gap_stakw" href="#AboutUs">
                About
              </Nav.Link>

              <Nav.Link
                className="headeder_links gap_stakw"
                onClick={handleClose}
                href="#Tokenomics"
              >
                Tokenomics
              </Nav.Link>

              <Nav.Link
                className="headeder_links gap_stakw"
                onClick={handleClose}
                href="#Roadmap"
              >
                Roadmap
              </Nav.Link>

              <Nav.Link
                className="headeder_links gap_stakw"
                onClick={handleClose}
                href="https://bscscan.com/token/0xd7b45bb6ac84ede2fb322773bce85fd21c1bfd2a"
                target="_blank"
              >
                Smart Contract
              </Nav.Link>

              <Nav.Link
                className="headeder_links gap_stakw"
                onClick={handleClose}
                href="#faq"
              >
                Faq
              </Nav.Link>
            
            </Nav>
            <Nav className="ms-auto d-flex  align-items-center gap-2">
              <div className="social-icons d-flex gap-3 align-items center ">
                <a
                  href=""
                  target="_blank"
                >
                  <button className="button-5">Whitepaper</button>
                </a>
              </div>
              <div className="tree_btn d-flex gap-2"></div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
